import { render, staticRenderFns } from "./GameListAddNew.vue?vue&type=template&id=f7d4e348&"
import script from "./GameListAddNew.vue?vue&type=script&lang=js&"
export * from "./GameListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./GameListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports